module.exports = __webpack_public_path__ + "static/media/pills.fed55dc5.png";